<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="chemicalPurchaseForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="chemicalPurchase" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                chemicalPurchaseForm: () => import('../forms/ChemicalPurchaseForm'),
                chemicalPurchase: () => import('../editViews/ChemicalPurchase'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Chemical', value: 'chemicalId', table: 'chemicals', form: () => import('../forms/ChemicalForm') },
                    { text: 'Dose Rate', value: 'doseRate' },
                    { text: 'Withholding Period In Days', value: 'withholdingPeriodInDays' },
                    { text: 'Prescription File', value: 'prescriptionFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'Invoice File', value: 'invoiceFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    chemicals: [],
                    files: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "doseRate", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "chemicalId", direction: "ascending" },
                ],
                itemsField: 'chemicalPurchases',
                editPageName: 'chemicalPurchase',
                apiMethod: 'ChemicalPurchases',
                claimName: 'ChemicalPurchases',
                formTitle: 'Chemical Purchase',
                excelTitle: 'Chemical Purchases',
                hasEditPage: true,
            }
        },
    };
</script>
